<template>
  <div class="c-news">
    <div class="c-news__title">お知らせ</div>
    <ul class="c-news__nav" v-if="news.length > 0">
      <li v-for="(item, index) in news" :key="index" v-show="item.is_top">
        <router-link
          class="-more-link"
          :to="{
            name: item.routerName,
            params: { mc_code: mcCode, id: item._id },
          }"
        >
          <div class="c-news__nav__item">
            <div class="c-news__arrow"></div>
            <div>
              {{ $date(item.registration_at).tz().format("YYYY.MM.DD") }}
            </div>
            <div class="c-news__newsTagWrap">
              <NewsTag :tagIndex="item.label" :text="statusText(item.label)" />
            </div>
            <div class="c-news__nav__item__spSpace">{{ item.title }}</div>
          </div>
        </router-link>
      </li>
    </ul>
    <div v-else class="c-news__blankText">現在、お知らせはありません。</div>
  </div>
</template>

<script>
import InfoService from "../services/info.service";
import GlobalInfoService from "../services/global-info.service";
import BoDInfoService from "../services/bod-info.service";
import NewsTag from "@/components/NewsTag.vue";
import dayjs from "@/libs/day.js";

export default {
  name: "News",
  components: {
    NewsTag,
  },
  data: function () {
    return {
      news: [],
    };
  },
  async mounted() {
    await this.$nextTick();
    await this.$nextTick();

    let news = [];

    const responseInfo = await InfoService.list({ is_top: true, limit: 100 });
    if (responseInfo.data.docs != undefined) {
      const addRouterNameToNews = this.addRouterNameToArrayIntoObject(
        responseInfo.data.docs,
        "information-detail"
      );
      news = addRouterNameToNews;
    }

    const responseGlobalInfo = await GlobalInfoService.findSchedule();
    if (responseGlobalInfo.length > 0) {
      const addRouterNameToNews = this.addRouterNameToArrayIntoObject(
        responseGlobalInfo,
        "global-information-detail"
      );
      news = [...news, ...addRouterNameToNews];
    }

    const responseBodInfo = await BoDInfoService.list({
      is_top: true,
      limit: 100,
    });
    if (responseBodInfo.data.docs != undefined) {
      const addRouterNameToNews = this.addRouterNameToArrayIntoObject(
        responseBodInfo.data.docs,
        "bod-information-detail"
      );
      news = [...news, ...addRouterNameToNews];
    }

    await this.sortNewsToDateOrder(news);

    this.news = news;
  },
  methods: {
    sortNewsToDateOrder: async (newsArr) => {
      // const self = this;
      newsArr.sort(
        (x, y) =>
          -(dayjs(x.registration_at).get('millisecond') - dayjs(y.registration_at).get('millisecond'))
      );
    },
    addRouterNameToArrayIntoObject: (arr, routerName) => {
      return arr.map((obj) => {
        obj.routerName = routerName;
        return obj;
      });
    },
  },
};
</script>

<style></style>
